var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", sm4: "" } }, [
            _c("h1", { staticClass: "primary--text" }, [
              _c("strong", [_vm._v("Click the button for report")])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { xs10: "" } },
            [
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: false },
                      on: { click: _vm.report }
                    },
                    [_vm._v("1 month")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: false },
                      on: { click: _vm.month3 }
                    },
                    [_vm._v("3 month")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: false },
                      on: { click: _vm.month6 }
                    },
                    [_vm._v("6 month")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.get_reports,
                    "hide-actions": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.art.artist_name))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.art.art_title))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(_vm.timestamp(props.item)))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v("1")
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      slot: "progress",
                      color: "blue",
                      indeterminate: ""
                    },
                    slot: "progress"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a9cd703", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9cd703","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/report.vue
// module id = null
// module chunks = 